
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9TMai", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1205afbc9aa751dc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $1205afbc9aa751dc$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "Scrivi qualcosa\u2026",
    'fabric.editor.editorAssistiveLabel': 'Area del contenuto principale; inizia a digitare per inserire il testo.',
    'fabric.editor.headingLink.toolbarHelpTitle': 'Apri finestra della guida'
};

});


//# sourceMappingURL=it.4252bbf4.js.map
